/** Canonical React path for a directly-held asset's detail screen. */
export function realAssetDetailPath(assetId: string): string {
  const id = assetId.trim();
  return id ? `/realassets/${id}` : '/realassets';
}

export function catalogueRealAssetPath(assetId: string): string {
  return `${realAssetDetailPath(assetId)}/catalogue`;
}

export function recordRealAssetAppraisalPath(assetId: string): string {
  return `${realAssetDetailPath(assetId)}/appraisal`;
}

export function encumberRealAssetPath(assetId: string): string {
  return `${realAssetDetailPath(assetId)}/encumber`;
}

export function releaseRealAssetEncumbrancePath(assetId: string): string {
  return `${realAssetDetailPath(assetId)}/release`;
}

export function recordCapitalImprovementPath(assetId: string): string {
  return `${realAssetDetailPath(assetId)}/improvement`;
}

export function recordDistributionReceivedPath(assetId: string): string {
  return `${realAssetDetailPath(assetId)}/distribution`;
}

export function enterOperatingStagePath(assetId: string): string {
  return `${realAssetDetailPath(assetId)}/operating-stage`;
}

/** The purchase screen that already exists, opened on this asset. */
export function bookRealAssetAcquisitionPath(assetId: string): string {
  return `${realAssetDetailPath(assetId)}/acquire`;
}

/** The gift screen that already exists, opened on this asset. */
export function giftRealAssetPath(assetId: string): string {
  return `${realAssetDetailPath(assetId)}/gift`;
}

/** The inheritance screen that already exists, opened on this asset. */
export function passRealAssetToBeneficiaryPath(assetId: string): string {
  return `${realAssetDetailPath(assetId)}/inheritance`;
}

/** The sale screen that already exists, opened on this asset. */
export function sellRealAssetPath(assetId: string): string {
  return `${realAssetDetailPath(assetId)}/sell`;
}

const assetActionPath =
  /^\/realassets\/[0-9a-fA-F-]{36}(\/(catalogue|appraisal|encumber|release|improvement|distribution|operating-stage|acquire|gift|inheritance|sell))?$/;

/** Detail and the capture screens that open from it — not sidebar leaves. */
export function isRealAssetFromAssetPath(pathname: string): boolean {
  return assetActionPath.test(pathname);
}
